import { Component, OnInit, Input, ChangeDetectorRef, AfterViewInit, OnDestroy } from '@angular/core';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { MatTableDataSource } from '@angular/material/table';
import { ApiService } from 'src/app/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import {FormGroup, FormControl} from '@angular/forms';
import * as moment from 'moment';
import { CommonService } from 'src/app/services/common.service';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { ErrorType } from 'src/app/enums/error-type.enum';
import endpoints from 'src/app/helpers/endpoints';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
interface hour {
  value: string;
  viewValue: string;
}


@Component({
  selector: 'fury-home-security-lead-list',
  templateUrl: './home-security-lead-list.component.html',
  styleUrls: ['./home-security-lead-list.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class HomeSecurityLeadListComponent implements OnInit, OnDestroy {

  selectConfig = {disableOptionCentering: true,panelClass: 'custom-class'}
  @Input()
  columns = [
    {name: 'Added On', property: 'addedOn', visible: true, isModelProperty: true},
    {name: 'Source', property: 'source', visible: true},
    {name: 'First Name', property: 'firstName', visible: true},
    {name: 'Last Name', property: 'lastName', visible: true},
    {name: 'Verified Name', property: 'verifiedName', visible: true},
    {name: 'Email', property: 'emailAddress', visible: true},
    {name: 'Mobile No', property: 'mobileNumber', visible: true},
    {name: 'Address', property: 'address', visible: true},
    {name: 'City', property: 'city', visible: true},
    {name: 'State', property: 'state', visible: true},
    {name: 'Zip Code', property: 'zipCode', visible: true},
    {name: 'Attempts', property: 'attempts', visible: true},
    {name: 'Result Code', property: 'resultCode', visible: true},
    {name: 'Status', property: 'vanillaSoftStatus', visible: true},
    {name: 'Last Agent Name', property: 'lastAgentName', visible: true},
    {name: 'Submission', property: 'submission', visible: true},
    {name: 'Last Date', property: 'vanillaSoftTimestamps', visible: true},
    {name: 'Lead Status', property: 'leadStatus', visible: true},
    {name: '3rd Party Status', property: 'thirdPartyStatus', visible: true},
    { name: 'Actions', property: 'actions', visible: true },
  ];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  itemList: any;
  filterValue: any;
  pageSize = 30;
  totalCount: number = 0;
  pageIndex: number = 0;
  today = new Date();
  month = this.today.getMonth();
  year = this.today.getFullYear();
  startDate:any;
  endDate: any;
   campaignOne = new FormGroup({
     start: new FormControl<Date | null>(null),
     end: new FormControl<Date | null>(null),
   });
   selectType = new FormGroup({
     type: new FormControl<string | null>('hourType'),
     hourValue: new FormControl(null),
   })

  leadSearchForm = new FormGroup({
    source: new FormControl(""),
    firstName: new FormControl(""),
    lastName: new FormControl(""),
    verifiedName: new FormControl(""),
    emailAddress: new FormControl(""),
    mobileNumber: new FormControl(""),
    address: new FormControl(""),
    city: new FormControl(""),
    state: new FormControl(""),
    zip: new FormControl(""),
    attempts: new FormControl(""),
    resultCode: new FormControl(""),
    status: new FormControl(""),
    lastAgentName: new FormControl(""),
  });
  ngUnsubscribe = new Subject<void>();
  kpiData: any;
  
  constructor(
    private apiservice: ApiService,
    private cdr: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public commonService: CommonService,
  ) { }
  get visibleColumns() {
    return this.columns
      .filter((column) => column.visible)
      .map((column) => column.property);
  }
  ngOnInit(): void { 
    const tomorrow = moment(this.today).add(1, "days").format('YYYY-MM-DD');    
    this.endDate = moment(tomorrow).subtract(1, "seconds").format('YYYY-MM-DD HH:mm:ss');
    this.startDate = moment(moment().format("YYYY-MM-DD")).subtract(30, "days").format("YYYY-MM-DD HH:mm:ss");
    this.filterValue = 'Home Security Leads';
    this.router.onSameUrlNavigation = 'reload';

    this.activatedRoute.queryParams.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any) => {
      this.pageIndex = res.page ? res.page - 1 : 0;
      this.pageSize = res.size ? (res.size === 'all' ? 9999 : res.size) : 30;
      this.getLeadRequestList();
    });
    this.getHomeSecurityKpiData();
  }
  pageSizeChange(event: any) {    
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.router.navigateByUrl(
      `/lead/home-security-lead-list?page=${this.pageIndex + 1
      }${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}`
    );
    this.getLeadRequestList();
  }
  getLeadRequestList() {
    const {source,firstName,lastName,verifiedName, emailAddress, mobileNumber, address, city, state,zip, attempts, resultCode, status, lastAgentName } = this.leadSearchForm.value;

    const queryParams =`?page=${Number(this.pageIndex) + 1}&size=${this.pageSize}&source=${source}&firstName=${firstName}&lastName=${lastName}&verifiedName=${verifiedName}&emailAddress=${emailAddress}&mobileNumber=${mobileNumber}&address=${address}&city=${city}&state=${state}&zip=${zip}&attempts=${attempts}&resultCode=${resultCode}&status=${status}&lastAgentName=${lastAgentName}&startDate=${this.startDate}&endDate=${this.endDate}`;
    this.apiservice
      .get(
        `${endpoints.leadManagement.getHomeSecurityLeads}${queryParams}`
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: HttpResponse<any>) => {
        if (res.body) {
          if (res.body.homeSecurityLeads.data) {
            this.itemList = res.body.homeSecurityLeads.data;
            this.totalCount = res.body.homeSecurityLeads.total;
            this.dataSource = new MatTableDataSource(this.itemList);
            this.cdr.detectChanges();
          } else {
            this.itemList = undefined;
          }
        }
      }, (err: HttpErrorResponse)=>{
        this.apiservice.alert(err.message, ErrorType.Error);
      });
  }
  navigateDetailsPage(data:any){
    this.router.navigateByUrl('/lead/lead-details/'+ data.leadId + '?type=customerInformation');
  }

  // lead Dashboard

   hours: hour[] = [
     {value: '4hrs', viewValue: '4hrs'},
     {value: '12hrs', viewValue: '12hrs'},
     {value: '24hrs', viewValue: '24hrs'},
     {value: '48hrs', viewValue: '48hrs'},
     {value: '72hrs', viewValue: '72hrs'},
     {value: '7days', viewValue: '7days'},
     {value: '14days', viewValue: '14days'},
     {value: '30days', viewValue: '30days'}
   ];

  dateRangeChange(dateRangeStart: HTMLInputElement, dateRangeEnd: HTMLInputElement){
    this.selectType.patchValue({
      hourValue: null
    })
    this.startDate = moment(this.campaignOne.value.start).format('YYYY-MM-DD HH:mm:ss');
    this.endDate = moment(this.campaignOne.value.end).format('YYYY-MM-DD HH:mm:ss');
    this.getLeadRequestList();
    this.getHomeSecurityKpiData();
  };
  hourRangeChange(e:any){
    this.campaignOne.patchValue({
      start: null,
      end: null
    })
    if(e.value === '4hrs'){
      this.startDate = moment().subtract(4, "hour").format("YYYY-MM-DD HH:mm:ss");
      this.endDate = moment().format('YYYY-MM-DD HH:mm:ss');
    } else if(e.value === '12hrs'){
      this.startDate = moment().subtract(12, "hour").format("YYYY-MM-DD HH:mm:ss");
      this.endDate = moment().format('YYYY-MM-DD HH:mm:ss');
    } else if(e.value === '24hrs'){
      this.startDate = moment().subtract(1, "days").format("YYYY-MM-DD HH:mm:ss");
      this.endDate = moment().format('YYYY-MM-DD HH:mm:ss');
    } else if(e.value === '48hrs'){
      this.startDate = moment().subtract(2, "days").format("YYYY-MM-DD HH:mm:ss");
      this.endDate = moment().format('YYYY-MM-DD HH:mm:ss');
    } else if(e.value === '72hrs'){
      this.startDate = moment().subtract(3, "days").format("YYYY-MM-DD HH:mm:ss");
      this.endDate = moment().format('YYYY-MM-DD HH:mm:ss');
    } else if(e.value === '7days'){
      this.startDate = moment().subtract(7, "days").format("YYYY-MM-DD HH:mm:ss");
      this.endDate = moment().format('YYYY-MM-DD HH:mm:ss');
    } else if(e.value === '14days'){
      this.startDate = moment().subtract(14, "days").format("YYYY-MM-DD HH:mm:ss");
      this.endDate = moment().format('YYYY-MM-DD HH:mm:ss');
    } else if(e.value === '30days'){
      this.startDate = moment().subtract(30, "days").format("YYYY-MM-DD HH:mm:ss");
      this.endDate = moment().format('YYYY-MM-DD HH:mm:ss');
    }
    this.getLeadRequestList();
    this.getHomeSecurityKpiData();
  }
  getHomeSecurityKpiData() {
    this.apiservice.get(`${endpoints.leadManagement.getHomeSecurityKpiData}?startDate=${this.startDate}&endDate=${this.endDate}`)
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe({
      next: (res: HttpResponse<any>) => {
        if(res.body) {
          this.kpiData = res.body;
        }
      },
      error: (err: HttpErrorResponse) => {
        this.apiservice.alert(err.message, ErrorType.Error);
      }
    })
  }
  ngOnDestroy(){
   this.ngUnsubscribe.next();
   this.ngUnsubscribe.complete();
  }

}
